import React from "react";
import HotelChainImage from "../../assets/images/clients/hotel_chain.png";
import FinancialServicesCompanyImage from "../../assets/images/clients/financial-services.png";
import HrStartupCompanyImage from "../../assets/images/clients/hr-startup.png";
import InsuranceCompanyImage from "../../assets/images/clients/insurance-company.png";
import TechCompanyImage from "../../assets/images/clients/tech-company.png";
import SoftwareCompanyImage from "../../assets/images/clients/software-company.png";

const caseStudies = [
  {
    title: "Leading Hotel Chain",
    desc: "A leading hotel chain was struggling to identify new leads for their properties. We provided them with a comprehensive database of potential customers, allowing them to increase their outreach and generate more leads.",
    icon: HotelChainImage
  },
  {
    title: "Financial Services",
    desc: "A financial services company was struggling to manage their growing list of leads and prioritize their sales efforts. We provided them with a customized lead management solution, allowing them to track and prioritize their leads more effectively and close more deals.",
    icon: FinancialServicesCompanyImage
  },
  {
    title: "HR Startup",
    desc: "A HR startup was looking to find more leads and needed an easy to use solution to help them identify and manage their outreach. We provided them with a targeted list of companies and helped them manage their leads.",
    icon: HrStartupCompanyImage
  },
  {
    title: "Tech Company",
    desc: "A mid-size tech company was looking to expand into new markets but didn't have the necessary data to make informed decisions. We provided them with detailed information on their target segment with market and competitive landscape, enabling them to identify new opportunities and make strategic business decisions.",
    icon: TechCompanyImage
  },
  {
    title: "Software Company",
    desc: "A software company was looking to expand their customer base and increase their revenue. They had been struggling to identify new leads and connect with potential customers. We provided them with our B2B data, which allowed them to identify and target new prospects. With our help, they were able to close deals with several new clients, resulting in a significant increase in their revenue.",
    icon: SoftwareCompanyImage
  },
  {
    title: "Insurance Company",
    desc: "An insurance company was looking to target specific industries and businesses with their marketing campaigns. They needed accurate data to help them identify potential customers and create targeted marketing campaigns. We provided them with our B2B data, which enabled them to identify and connect with the right prospects. With our help, they were able to increase their sales and expand their customer base.",
    icon: InsuranceCompanyImage
  }
];

const CaseStudy = () => {
  return (
    <section className="tw-py-20 lg:tw-py-24 tw-bg-white" id="case-studies">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16 tw-max-w-3xl tw-mx-auto">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Real Stories, Real Results
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
            Case Studies
          </h2>
          <p className="tw-text-sm sm:tw-text-base tw-text-slate-500 tw-leading-relaxed">
            Our commitment to delivering high-quality data and innovative lead management solutions has resulted in many happy clients over the years. Here are some examples of how we have helped businesses grow and succeed:
          </p>
        </div>

        {/* Card Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {caseStudies.map((item, idx) => (
            <div
              key={idx}
              className="tw-group tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Ghost Watermark Icon */}
              <img
                src={item.icon}
                alt=""
                className="tw-absolute tw-bottom-[-16px] tw-right-[-16px] tw-w-28 tw-h-28 tw-opacity-[0.05] tw-pointer-events-none"
              />

              {/* Icon container */}
              <div className="tw-w-14 tw-h-14 tw-rounded-2xl tw-border tw-border-solid tw-flex tw-items-center tw-justify-center tw-mb-6 tw-bg-[#EEF2FF] tw-border-[#C7D2FE]">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="tw-w-8 tw-h-8 tw-object-contain tw-transition-transform tw-duration-300 group-hover:tw-scale-105"
                  loading="lazy"
                />
              </div>

              {/* Title */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {item.title}
              </h3>

              {/* Description */}
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Footer text */}
        <p className="tw-text-center tw-text-sm sm:tw-text-base tw-font-medium tw-text-slate-600 tw-max-w-3xl tw-mx-auto tw-mt-12">
          These are just a few examples of how we have helped our clients achieve their goals and grow their businesses. We are committed to delivering the best possible outcomes for our partners and are always happy to see them succeed.
        </p>

      </div>
    </section>
  );
};

export default CaseStudy;
